import { readFileSync } from 'fs';
import { join } from 'path';

/**
 * Get package version at runtime from package.json
 * Works in both development (src/) and production (dist/cli/) contexts
 */
function getVersion(): string {
  // Possible locations of package.json relative to this file:
  // - Development: src/version.ts -> ../package.json
  // - Production (bundled): dist/cli/index.js -> ../../package.json
  const possiblePaths = [
    join(__dirname, '../../package.json'), // dist/cli/ -> root
    join(__dirname, '../package.json'), // src/ -> root
  ];

  for (const packagePath of possiblePaths) {
    try {
      const content = readFileSync(packagePath, 'utf-8');
      const packageJson = JSON.parse(content) as { version?: string };
      if (packageJson.version) {
        return packageJson.version;
      }
    } catch {
      // Try next path
    }
  }

  return '0.0.0';
}

export const VERSION = getVersion();
